<template lang="pug">
  div
    sidebar
      transition-group.group-list(
        name="list-complete",
        mode="out-in",
        tag="ul")
        li.list-complete-item(key="profile")
          router-link.group-link(:to="{name: 'profile'}")
            span {{$t('profile')}}
        li.list-complete-item(v-if="AppState.perm.isAdmin && !AppState.isMobile", key="managers")
          router-link.group-link(:to="{name: 'managers'}")
            span {{$t('user')}}
        li.list-complete-item(v-if="AppState.perm.isAdmin", key="groups")
          router-link.group-link(:to="{name: 'group-root'}")
            span {{$t('group')}}
        template(v-if="AppState.perm.isApprover")
          li.list-complete-item(v-if="!AppState.perm.isAdmin && summary.use_approval", key="access-user")
            router-link.group-link(:to="{name: 'access-user'}")
              span {{$t('request-history')}}
          //template(v-if="AppState.perm.isAdmin || AppState.perm.isSubManager")
            li.list-complete-item(key="access")
              router-link.group-link(:to="{name: 'access-registration'}")
                span {{$t('approval-process')}}
            li.list-complete-item(key="access-history")
              router-link.group-link(:to="{name: 'access-registration-view'}")
                span {{$t('approval-process-history')}}
        template(v-if="AppState.perm.isAdmin")
          li.list-complete-item(v-if="summary.common_policy" key="function-settings")
            router-link.group-link(:to="{name: 'function-settings'}")
              span {{$t('function-settings')}}
          li.list-complete-item(v-if="summary.ip_policy" key="blocking-settings")
            router-link.group-link(:to="{name: 'blocking-settings'}")
              span {{$t('blocking-settings')}}
    div.lmm-content-body
      router-view
</template>

<script>
import Sidebar from '../mixins/sidebar'
import store from '@/api/store'

export default {
  name: 'manage-component',
  components: { 'sidebar': Sidebar },
  methods: {
    getUserData () {
      let stored = store.get('summary')
      this.summary = stored
    }
  },
  created () {
    this.getUserData()
  },
  data () {
    return {
      summary: {}
    }
  }
}
</script>

<style lang="scss" scoped>
.group-list {
  padding: 0;
  margin: 15px 0 0 9px;
  list-style: none;
  font-size: 14px;
  
  li {
    height: 35px;
    line-height: 35px;

    .group-link {
      display: block;
      width: 100%;
      padding: 0 0 0 12px;
      text-align: left;
      font-weight: 400;
      color: #6F6F6F;

      &.router-link-exact-active,
      &.router-link-active {
        color: $mainTheme;
        //background-color: #38d2b8;
        > span { font-weight: bolder; }
      }
      &:hover {
        // background-color: #16232d;
        color: #16191F;
      }
      > svg { vertical-align: middle; }
      > span {
        display: inline-block;
        padding: 1px 10px;
        vertical-align: top;
      }
    }

    &.active .group-link {
      background-color: #38d2b8;
      color: #fff;
    }
  }
}

.list-complete-item {
  transition: transform 500ms;
}
.list-complete-enter {
  transform: translateX(-220px);
}
.list-complete-leave-to {
  // transform: translateX(220px);
  display: none;
}
.list-complete-leave-active {
  // position: absolute;
}
</style>
